module.exports = __webpack_public_path__ + "static/media/license.0e74176e.svg";